module.exports = __webpack_public_path__ + "img/arrow.1c66c3d5.svg";